import { useContext, useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import * as Yup from 'yup';

import { Form, Select, Text } from '../../../Components/Form';
import Loading from '../../../Components/Loading/Loading';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { serverErrorHandler, sportTypes } from '../../../Utils/Helpers';
import { SportContext } from '../Context/SportContext';

const validationSchema = Yup.object({
  title: Yup.string()
    .typeError('عنوان الزامی است')
    .required('عنوان الزامی است')
    .max(190, 'عنوان نمی تواند بیشتر از 190 کاراکتر باشد'),
  type: Yup.number()
    .typeError('نوع رشته الزامی است')
    .required('نوع رشته الزامی است'),
});

const Edit = () => {
  const { id } = useParams();
  const [formSubmitLoading, setFormSubmitLoaing] = useState(false);
  const [serverErrors, setServerErrors] = useState({});
  const { get, put } = useApi();
  const { error, success } = useToast();
  const context = useContext(SportContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getData = async () => {
      await getSport();
    };
    getData();
  }, [id]);

  const getSport = async () => {
    setLoading(true);
    await get(
      `/sport/${id}`,
      (res) => {
        context.sport = res.data;
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };

  const submitForm = async (values, setSubmitingForm) => {
    setFormSubmitLoaing(true);
    await put(
      `/sport/${id}`,
      values,
      (res) => {
        success(`رشته "${context?.sport?.title}" باموفقیت ویرایش شد.`);
        setFormSubmitLoaing(false);
        getSport();
      },
      (err) => {
        console.log(err);
        if (err?.status === 422) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاهای فرم را رفع کنید.');
        } else {
          error(`رشته "${context?.sport?.title}" به علت خطا ایجاد نشد.`);
        }
        setFormSubmitLoaing(false);
      },
    );
  };
  return loading ? (
    <Loading />
  ) : (
    <Master>
      <TitleBar
        title={`ویرایش رشته ${context.sport?.title} `}
        showBackBtn={true}
        showCreateBtn={false}
        showFilterBtn={false}
        backPath='/sport'
      />
      <Form
        initialValues={{
          title: context.sport?.title,
          type: context?.sport?.type ?? 0,
        }}
        loading={formSubmitLoading}
        onSubmit={submitForm}
        validationSchema={validationSchema}
      >
        <div className='row'>
          <div className='col-12 col-md-8'>
            <div className='row'>
              <div className='col-12'>
                <Text
                  title='عنوان'
                  name='title'
                  serverError={serverErrors.title}
                />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-4'>
            <div className='col-12'>
              <Select
                title='نوع رشته'
                name='type'
                serverError={serverErrors?.type}
                options={sportTypes}
              />
            </div>
          </div>
        </div>
      </Form>
    </Master>
  );
};

export default Edit;
